import type { NotificationInstance } from "antd/es/notification/interface";

export const validateRequiredFields = <
    T extends Record<string, string | undefined>,
>(
    fields: T,
    messages: Record<keyof T, string>,
    notification: NotificationInstance,
): fields is T & { [K in keyof T]: string } => {
    const missingField = (Object.keys(fields) as Array<keyof T>).find(
        (field) => !fields[field],
    );

    if (!missingField) {
        return true;
    }

    notification.error({ title: messages[missingField] });

    return false;
};
